import React, { useEffect } from "react";
import { FormField } from "./FormField";
import styles from "./styles.module.scss";
import { useFormStore } from "src/store/dataEntryForm";
import { Select } from "antd";
import { DollarSign } from "lucide-react";

interface SearchQueryPerformanceFormProps {
  formId: string;
  onSubmit?: () => void;
}

const historicalTrendsOptions = [
  { value: "increasing", label: "Increasing" },
  { value: "decreasing", label: "Decreasing" },
  { value: "stable", label: "Stable" },
  { value: "fluctuating", label: "Fluctuating" },
  { value: "seasonal", label: "Seasonal" },
];

export const SearchQueryPerformanceForm: React.FC<
  SearchQueryPerformanceFormProps
> = ({ formId, onSubmit }) => {
  const { initializeForm, resetForm, updateFormField, formData } =
    useFormStore();

  const handleHistoricalTrendsChange = (value: string) => {
    updateFormField(formId, "historicalTrends", value);
  };

  useEffect(() => {
    initializeForm(formId, {
      brandVisibilityScore: "",
      averageCPC: "",
      competitorClickShare: "",
      historicalTrends: "",
      organicShare: "",
      sponsoredShare: "",
    });

    return () => resetForm(formId);
  }, [formId, initializeForm, resetForm]);

  const historicalTrendsValue = formData[formId]?.historicalTrends || "";

  return (
    <div className={styles.addSkuContainer}>
      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="brandVisibilityScore"
          label="Brand Visibility Score, %"
          placeholder=""
          type="number"
          size="small"
        />
        <FormField
          formId={formId}
          fieldName="averageCPC"
          label="Average CPC per Query"
          placeholder=""
          type="number"
          size="small"
          icon={<DollarSign size={20} color="#7C7C78" />}
        />
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="competitorClickShare"
          label="Competitor Click Share, %"
          placeholder=""
          type="number"
          size="large"
        />
        <div className={styles.selectWrapper}>
          <label htmlFor="asin-select" className={styles.fieldLabel}>
            Historical Trends
          </label>
          <Select
            id="asin-select"
            placeholder="Select trend"
            value={historicalTrendsValue || undefined}
            onChange={handleHistoricalTrendsChange}
            options={historicalTrendsOptions}
            className={styles.typeSelect}
            style={{ width: "100%" }}
            popupClassName="custom-select-dropdown"
          />
        </div>
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="organicShare"
          label="Organic share, %"
          placeholder=""
          type="number"
          size="small"
        />
        <FormField
          formId={formId}
          fieldName="sponsoredShare"
          label="Sponsored Share, %"
          placeholder=""
          type="number"
          size="small"
        />
      </div>
    </div>
  );
};
